import script from "./MermaidDiagram.vue?vue&type=script&lang=ts&setup=true"
export * from "./MermaidDiagram.vue?vue&type=script&lang=ts&setup=true"

import "./MermaidDiagram.vue?vue&type=style&index=0&id=1ea0be08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea0be08"]])

export default __exports__